/**
 * Created by fky on 23/03/2017.
 */
'use strict';
angular.module('betosyswebapp')
  .directive('inputNumberValidate', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        if (attr.inputNumberValidate === 'integer') {
          $(element).on('keypress', function (event) {
            return event.charCode >= 48 && event.charCode <= 57 || event.keyCode === 8 || event.keyCode === 9;
          });
        } else {
          $(element).on('keypress', function (event) {
            return event.charCode >= 48 && event.charCode <= 57 || event.charCode === 46 || event.keyCode === 8 || event.keyCode === 9;
          });
        }
      }
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/inputNumberValidate.js